export default __webpack_public_path__ + "static/math-cover-64c14829dbd4c805e3eeabdb6a7402eb.jpg";